import type { LevelDef } from '../levels';

// Diamond — 20 types × 3 = 60 tiles
// Layer 0: 5×7 base (35)   Layer 1: 4×5 middle (20)   Layer 2: 1×5 peak (5)
export const LEVEL_DIAMOND: LevelDef = {
  id: 'level-diamond',
  name: 'Diamond',
  seed: 1379,
  tileTypes: 20,
  maxRowX2: 8,
  maxColX2: 12,
  placements: [
    { rowX2: 0, colX2: 0,  layer: 0 }, { rowX2: 0, colX2: 2,  layer: 0 }, { rowX2: 0, colX2: 4,  layer: 0 },
    { rowX2: 0, colX2: 6,  layer: 0 }, { rowX2: 0, colX2: 8,  layer: 0 }, { rowX2: 0, colX2: 10, layer: 0 },
    { rowX2: 0, colX2: 12, layer: 0 },
    { rowX2: 2, colX2: 0,  layer: 0 }, { rowX2: 2, colX2: 2,  layer: 0 }, { rowX2: 2, colX2: 4,  layer: 0 },
    { rowX2: 2, colX2: 6,  layer: 0 }, { rowX2: 2, colX2: 8,  layer: 0 }, { rowX2: 2, colX2: 10, layer: 0 },
    { rowX2: 2, colX2: 12, layer: 0 },
    { rowX2: 4, colX2: 0,  layer: 0 }, { rowX2: 4, colX2: 2,  layer: 0 }, { rowX2: 4, colX2: 4,  layer: 0 },
    { rowX2: 4, colX2: 6,  layer: 0 }, { rowX2: 4, colX2: 8,  layer: 0 }, { rowX2: 4, colX2: 10, layer: 0 },
    { rowX2: 4, colX2: 12, layer: 0 },
    { rowX2: 6, colX2: 0,  layer: 0 }, { rowX2: 6, colX2: 2,  layer: 0 }, { rowX2: 6, colX2: 4,  layer: 0 },
    { rowX2: 6, colX2: 6,  layer: 0 }, { rowX2: 6, colX2: 8,  layer: 0 }, { rowX2: 6, colX2: 10, layer: 0 },
    { rowX2: 6, colX2: 12, layer: 0 },
    { rowX2: 8, colX2: 0,  layer: 0 }, { rowX2: 8, colX2: 2,  layer: 0 }, { rowX2: 8, colX2: 4,  layer: 0 },
    { rowX2: 8, colX2: 6,  layer: 0 }, { rowX2: 8, colX2: 8,  layer: 0 }, { rowX2: 8, colX2: 10, layer: 0 },
    { rowX2: 8, colX2: 12, layer: 0 },
    { rowX2: 1, colX2: 1,  layer: 1 }, { rowX2: 1, colX2: 3,  layer: 1 }, { rowX2: 1, colX2: 5,  layer: 1 },
    { rowX2: 1, colX2: 7,  layer: 1 }, { rowX2: 1, colX2: 9,  layer: 1 },
    { rowX2: 3, colX2: 1,  layer: 1 }, { rowX2: 3, colX2: 3,  layer: 1 }, { rowX2: 3, colX2: 5,  layer: 1 },
    { rowX2: 3, colX2: 7,  layer: 1 }, { rowX2: 3, colX2: 9,  layer: 1 },
    { rowX2: 5, colX2: 1,  layer: 1 }, { rowX2: 5, colX2: 3,  layer: 1 }, { rowX2: 5, colX2: 5,  layer: 1 },
    { rowX2: 5, colX2: 7,  layer: 1 }, { rowX2: 5, colX2: 9,  layer: 1 },
    { rowX2: 7, colX2: 1,  layer: 1 }, { rowX2: 7, colX2: 3,  layer: 1 }, { rowX2: 7, colX2: 5,  layer: 1 },
    { rowX2: 7, colX2: 7,  layer: 1 }, { rowX2: 7, colX2: 9,  layer: 1 },
    { rowX2: 3, colX2: 2,  layer: 2 }, { rowX2: 3, colX2: 4,  layer: 2 }, { rowX2: 3, colX2: 6,  layer: 2 },
    { rowX2: 3, colX2: 8,  layer: 2 }, { rowX2: 3, colX2: 10, layer: 2 },
  ],
};
